import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2 } from "lucide-react";
import { admin } from "@/lib/api";
import { Field, TabHeader, inputCls, textareaCls } from "@/admin/ui";

const PAGES = [
  ["/", "Home"],
  ["/about", "About"],
  ["/services", "Services"],
  ["/resources", "Resources"],
  ["/blog", "Blog"],
  ["/faq", "FAQ"],
  ["/book", "Book Now"],
  ["/contact", "Contact"],
  ["/privacy", "Privacy Policy"],
];

export default function SeoTab() {
  const [pages, setPages] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    admin.getSeo().then((d) => setPages(d.pages || {})).catch(() => toast.error("Could not load SEO settings"));
  }, []);

  if (!pages) return null;

  const set = (path, key) => (e) =>
    setPages((p) => ({ ...p, [path]: { ...(p[path] || {}), [key]: e.target.value } }));

  const save = async () => {
    setSaving(true);
    try {
      await admin.saveSeo({ pages });
      toast.success("SEO saved — live now");
    } catch {
      toast.error("Save failed — please try again");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-seo-tab">
      <TabHeader title="SEO" description="Search-engine title and description for every page." />
      <div className="mt-8 space-y-5">
        {PAGES.map(([path, label]) => (
          <div key={path} className="rounded-2xl border border-border bg-card p-6 shadow-soft" data-testid={`seo-page-${label.toLowerCase().replace(/\s/g, "-")}`}>
            <p className="text-sm font-semibold text-foreground">
              {label} <span className="ml-1 font-normal text-muted-foreground">{path}</span>
            </p>
            <div className="mt-4 grid gap-4">
              <Field label="Title tag">
                <input className={inputCls} value={pages[path]?.title || ""} onChange={set(path, "title")} data-testid={`seo-title-${path === "/" ? "home" : path.slice(1)}`} />
              </Field>
              <Field label="Meta description">
                <textarea className={textareaCls} rows={2} value={pages[path]?.description || ""} onChange={set(path, "description")} data-testid={`seo-desc-${path === "/" ? "home" : path.slice(1)}`} />
              </Field>
            </div>
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} data-testid="admin-seo-save" className="btn-primary mt-8 disabled:opacity-60">
        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
        {saving ? "Saving…" : "Save SEO"}
      </button>
    </div>
  );
}
